import React from "react";
import "./Reports.css";
import config from "./config";
import RemoteAnalysisButton from "./RemoteAnalysisButton";

// The reports page uses the same consent and billing contract as the team dashboard.
const Reports = ({ team }) => (
  <div className="reports-container">
    <h2>Team connectivity reports</h2>
    <p>Request a five-minute analysis from a team member. Their device asks permission,
      and the PDF is emailed to both of you. Each completed report uses one of your report credits.</p>
    <div className="team-members-list">
      {team?.map(member => (
        <div key={member.UserId} className="team-member-item">
          <span>{member.UserFirstName} {member.UserLastName}</span>{" "}
          <RemoteAnalysisButton apiBaseUrl={config.API_URL} token={localStorage.getItem("token") || ""}
            targetUserId={member.UserId} targetName={`${member.UserFirstName || ""} ${member.UserLastName || ""}`.trim() || "team member"}/>
        </div>
      ))}
    </div>
  </div>
);

export default Reports;
